<template>
    <div class="fw-fxfbs">
        <div class="fxfbs-user">
            <div class="fxfbs-l">
                <div class="svd-l">
                    <span v-if="dept.levelVal"> V{{dept.levelVal}}</span>
                    <span v-if="!dept.levelVal"> V0</span>
                </div>
            </div>
            <div class="fxfbs-r">
                <div class="s">
                    <img src="../../assets/nan.png" class="fxfbs-img" v-if="user.sex==1"/>
                    <img src="../../assets/nv.png" class="fxfbs-img" v-if="user.sex==0"/>
               <div>
                   <p style="font-size: 14px;margin-bottom: 6px">{{user.name}}</p>
                   <p style="font-size: 11px;">{{user.phone}}</p>
               </div>
                </div>
                <span class="z">为您推荐梵博士数字服务系统</span>
                <span class="x" @click="toRegister">预约开通</span>
            </div>
        </div>
        <div>
            <van-tabs v-model="activeName" @click="onClick" swipe-threshold="4">
                <van-tab v-for="item in tabs" :title="item.label" />
            </van-tabs>
            <van-tabs v-model="catIndex" v-if="cats.length>0" style="margin-top: 5px" @click="catClick" swipe-threshold="4" >
                <van-tab v-for="item in cats" :title="item.label"/>
            </van-tabs>
        </div>
        <div class="tw-items" v-if="catType!=1">
            <div class="tw-item" v-for="item in list" @click="toPage(catType,item)">
                <img :src="item.imgUrl" class="twitem-img"/>
                <span class="tw-jieshao">{{item.introduce}}</span>
                <span class="tw-btn">查看</span>
            </div>
        </div>
        <div class="tw-spus" v-if="catType==1" >
            <div v-for="item in items" v-if="items.length>0">
                <Style1 v-if="item.styleNum == 1" :imgMap="item.imgMap"/>
                <Style2 v-if="item.styleNum == 2" :imgMap="item.imgMap"/>
                <Style3 v-if="item.styleNum == 3" :imgMap="item.imgMap"/>
                <Style4 v-if="item.styleNum == 4" :imgMap="item.imgMap"/>
            </div>
            <div class="ptc-items" v-if="items.length<=0">
                <div class="ptc-item" v-for="item in list" @click="toPage(catType,item)">
                    <img :src="item.imgUrl"  class="spu-img"/>
                    <div class="spu-info">
                        <div class="spu-xinxi">
                            <span class="spu-name">{{item.spuName}}</span>
                            <span class="spu-yj">原价: {{item.costPrice}}</span>
                            <span class="spu-sj">¥: {{item.skuPrice}}</span>
                        </div>
                        <div class="spu-xssl">
                            <span style="font-size: 9px">已售 {{item.salesVolume}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import Zb from "../home/zb";
    import Md from "../home/md";
    import Emp from "../home/emp";

    export default {
        components: {},
        data() {
            return {
                deptId: '',
                dept:{},
                user:{},
                activeName:0,
                tabs:[],
                catIndex:0,
                cats:[],
                parentId:'',
                catId:'',
                catType:'',
                catStatus:1,
                list:[],
                items:[],
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.userId=this.$route.query.userId
            this.getSysCats()
            this.getShareUser()
        },

        methods: {
            async getShareUser() {
                let res = await this.$get("/fw/getShareUser",{userId:this.userId})
                this.dept = res.dept
                this.user = res.user
            },
            async getSysCats() {
                let res = await this.$get("/fw/getSysCats")
                this.tabs = res.list
                if (res.list.length>0){
                    let item=JSON.parse(JSON.stringify(res.list[0]))
                    this.catType=item.catType
                    this.parentId=item.id
                    this.catStatus=1
                    if (item.children&&item.children.length>0){
                        item.children.unshift({
                            label:'全部分类',
                            id:'-1',
                        })
                        this.cats=item.children
                        this.catId=''
                        this.catStatus=2
                    }
                    this.getSpuImgTexts()
                }
            },
            onClick(val){
                let item = this.tabs[val]
                this.catType=item.catType
                this.parentId=item.id
                this.catStatus=1
                var cat =JSON.parse(JSON.stringify(item))
                if (cat.children&&cat.children.length>0){
                    cat.children.unshift({
                        label:'全部分类',
                        id:'-1',
                    })
                    this.cats=cat.children
                    this.catId=''
                    this.catStatus=2
                }else {
                    this.cats=[]
                    this.catId=''
                    this.catStatus=1

                }
                this.getSpuImgTexts()
            },
            catClick(){
                let id =this.cats[this.catIndex].id
                this.catId=id=='-1'?'':id
                this.getSpuImgTexts()
            },
            async getSpuImgTexts() {
                let data={
                    catId:this.catId,
                    parentId:this.parentId,
                    catType:this.catType,
                    catStatus:this.catStatus,
                    isLogin:"0",
                }
                let res = await this.$get("/fw/getSpuImgTexts",data)
                this.list = res.list
                this.items = res.items
            },
            toPage(catType,item){
                if (catType==1){
                    //商品
                    this.$router.push('/spuDetails?spuId='+item.id)
                }else {
                    if (item.itType==2){
                        this.$router.push('/itinfo?id=' + item.id)
                    }
                    if (item.itType==3){
                        const url = item.videoLink
                        window.location.href = url;
                    }
                }
            },
            toRegister(){
                this.$router.push('/yykt?deptId='+this.dept.id+'&deptName='+this.dept.deptName)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-fxfbs {
        margin: 0 auto;
        height: 100%;
        background-color: #ffffff;
        position: relative;
    }
    .fxfbs-user{
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: #e5e5e5 solid 1px;
        height: 150px;
    }
    .fxfbs-l{
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .fxfbs-r{
        width: 50%;
        display: flex;
        flex-direction: column;
        padding: 8px 10px;
    }

    .fxfbs-img{
        width: 45px;
        height: 45px;
        margin-right: 8px;
    }
    .fxfbs-r .s{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px;
        font-size: 15px;
    }
    .fxfbs-r .z{
        padding: 0 5px;
        font-size: 12px;
    }
    .fxfbs-r .x{
        text-align: center;
        width: 60%;
        padding: 5px;
        font-size: 12px;
        background-color: #092E2E;
        color: #ffffff;
        margin-top: 15px;
    }
    .tw-items{
        margin-top: 15px;
        padding: 0 8px;
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }

    .tw-item {
        flex: 1;
        box-sizing: border-box;
        padding-bottom: 8px;
        margin-bottom: 8px;
        border: #e5e5e5 solid 1px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: calc((100% - 15px) / 2);
        min-width: calc((100% - 15px) / 2);
        max-width: calc((100% - 15px) / 2);
        &:nth-child(2n + 2) {
            margin-right: 0;
        }
    }
    .twitem-img{
        width: 100%;
    }
    .tw-jieshao{
        font-size: 11px;
        padding: 10px 5px;
        text-align: center;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .tw-btn{
        width: 85%;
        padding: 5px 0;
        text-align:center;
        font-size: 14px;
        border: #e5e5e5 solid 1px;
        margin-top: 13px;
    }

    .tw-spus{
        margin-top: 15px;
        padding: 0 8px;
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .tw-spus-item{
        width: 100%;
    }
</style>
